import MuiButton from './MuiButton';
import MuiIconButton from './MuiIconButton';
import MuiPaper from './MuiPaper';
import MuiTableCell from './MuiTableCell';
import MuiTableHead from './MuiTableHead';
import MuiTypography from './MuiTypography';

export default {
  MuiButton: { styleOverrides: MuiButton },
  MuiIconButton: { styleOverrides: MuiIconButton },
  MuiPaper: { styleOverrides: MuiPaper },
  MuiTableCell: { styleOverrides: MuiTableCell },
  MuiTableHead: { styleOverrides: MuiTableHead },
  MuiTypography: { styleOverrides: MuiTypography },
};

export const v4Overrides = {
  MuiDropzonePreviewList: {
    root: {
      width: '100%',
    },
    image: {
      height: 140,
      objectFit: 'cover',
    },
  },
};